import RatingPage from '@app-studio-web/ui/pages/RatingPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'clutterLevel'

const ANSWER_TEXTS = {
  '1': 'Minimal/empty',
  '2': 'Mostly organized',
  '3': 'Moderately cluttered',
  '4': 'Quite cluttered',
  '5': 'Very cluttered/full',
}

export default function ClutterLevelPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(ANSWER_TEXTS).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the rating value from the form
    const formData = new FormData(event.currentTarget)
    const rating = formData.get('rating') as string

    if (!rating) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How "cluttered" does your space feel right now?',
      answer_key: rating,
      answer: ANSWER_TEXTS[rating as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  return (
    <RatingPage
      heading={t('pages.onboarding.clutterLevel.heading')}
      leftText={t('pages.onboarding.clutterLevel.options.1')}
      rightText={t('pages.onboarding.clutterLevel.options.5')}
      onSubmit={handleSubmit}
      buttonBgColor="bg-white"
      headingSize="text-3xl"
      preselectedValue={preselectedValue}
    />
  )
}
